var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/congrat_phase.e1e09467.png","uri@2x": __webpack_public_path__ + "static/media/congrat_phase.59d6e79e.png","uri@3x": __webpack_public_path__ + "static/media/congrat_phase.c8f5c740.png",
    width: 221,
    height: 220
});